/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import styled from '@emotion/styled';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';
import { color } from '@coursera/coursera-ui';
import { SvgStarFilled } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/enterprise-admin-skills';

const Header = styled.div({
  borderColor: color.divider,
  borderStyle: 'solid',
  borderWidth: '1px 0',
  padding: '9px 0',
  display: 'flex',
  alignItems: 'center',
});

export const SkillSetCardHeader: React.FC<{ skillCount: number }> = ({ skillCount }) => (
  <Header>
    <div css={{ width: '55%' }}>
      <Typography2 component="strong">
        <FormattedMessage
          message={_t('{number} {number, plural, =1 {Skill} other {Skills}}')}
          number={String(skillCount)}
        />
      </Typography2>
    </div>
    <div css={{ width: '30%' }}>
      <Typography2 component="p">{_t('Target level / score')}</Typography2>
    </div>
    <div css={{ width: '15%' }}>
      <div css={{ display: 'flex', justifyContent: 'center' }}>
        <SvgStarFilled size={21} color="#FFC300" />
      </div>
    </div>
  </Header>
);
